import React, { useState, useEffect } from 'react'
import validate from 'validate.js'
import { makeStyles } from '@material-ui/styles'
import { Grid, TextField, InputAdornment, IconButton } from '@material-ui/core'
import { Visibility, VisibilityOff, Lock, Person } from '@material-ui/icons'

const schema = {
  senha: {
    presence: { allowEmpty: false, message: '^Senha é obrigatório' },
    length: {
      minimum: 8,
      message: '^No mínimo 8 caracteres',
    },
  },
  senhaVerificar: {
    presence: {
      allowEmpty: false,
      message: '^Repetir senha é obrigatório',
    },
    equality: {
      attribute: 'senha',
      message: '^As senhas devem ser iguais',
    },
  },
}

const useStyles = makeStyles((theme) => ({
  root: {},

  fields: {
    margin: theme.spacing(-1),
    display: 'flex',
    flexWrap: 'wrap',
    '& > *': {
      flexGrow: 1,
      margin: theme.spacing(1),
    },
  },

  alert: {
    marginBottom: theme.spacing(2),
  },
  iconAdornment: {
    color: '#64748B', // Ícones decorativos cinza fixo
    marginRight: theme.spacing(1),
  },

  passwordToggle: {
    padding: 8,
    color: '#64748B', // Olho de visualização de senha cinza fixo
  },
}))

export const Formulario = (props) => {
  const { usuario, form, setForm, onValidityChange } = props
  const classes = useStyles()
  const [showPassword, setShowPassword] = useState(false)
  const [isValid, setIsValid] = useState(false)
  const [touched, setTouched] = useState({})
  const [errors, setErrors] = useState({})

  useEffect(() => {
    const validationErrors = validate(form, schema)

    const formIsValid = !validationErrors
    setIsValid(formIsValid)
    setErrors(validationErrors || {})
    onValidityChange(formIsValid)
  }, [form, onValidityChange])

  const toggleShowPassword = () => {
    setShowPassword((prev) => !prev)
  }

  const changeForm = (campo, valor) => {
    setForm((prevState) => ({
      ...prevState,
      [campo]: valor,
    }))
  }

  const handleChange = (event) => {
    event.persist()
    const { name, type, checked, value } = event.target

    changeForm(name, type === 'checkbox' ? checked : value)
    setTouched((prevState) => ({
      ...prevState,
      [name]: true,
    }))
  }

  const handleSubmit = (event) => {
    event.preventDefault()
    if (!isValid) {
      return
    }
  }

  const hasError = (field) => touched[field] && errors[field]

  return (
    <form className={classes.root} onSubmit={handleSubmit}>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <TextField
            disabled
            fullWidth
            label="CPF"
            name="cpf"
            value={usuario.cpf || ''}
            variant="outlined"
            required
            InputProps={{
              startAdornment: (
                <InputAdornment position="start" className={classes.iconAdornment}>
                  <Person fontSize="small" />
                </InputAdornment>
              ),
            }}
          />
        </Grid>
        <Grid item xs={12}>
          <TextField
            error={hasError('senha')}
            fullWidth
            helperText={hasError('senha') ? errors.senha[0] : null}
            label="Senha"
            name="senha"
            onChange={handleChange}
            type={showPassword ? 'text' : 'password'}
            value={form.senha || ''}
            variant="outlined"
            required
            InputProps={{
              startAdornment: (
                <InputAdornment position="start" className={classes.iconAdornment}>
                  <Lock fontSize="small" />
                </InputAdornment>
              ),
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton aria-label="Alternar visibilidade da senha" onClick={toggleShowPassword} edge="end" className={classes.passwordToggle}>
                    {showPassword ? <VisibilityOff /> : <Visibility />}
                  </IconButton>
                </InputAdornment>
              ),
            }}
          />
        </Grid>
        <Grid item xs={12}>
          <TextField
            error={hasError('senhaVerificar')}
            fullWidth
            helperText={hasError('senhaVerificar') ? errors.senhaVerificar[0] : null}
            label="Repetir senha"
            name="senhaVerificar"
            onChange={handleChange}
            type={showPassword ? 'text' : 'password'}
            value={form.senhaVerificar || ''}
            variant="outlined"
            required
            InputProps={{
              startAdornment: (
                <InputAdornment position="start" className={classes.iconAdornment}>
                  <Lock fontSize="small" />
                </InputAdornment>
              ),
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton aria-label="Alternar visibilidade da senha" onClick={toggleShowPassword} edge="end" className={classes.passwordToggle}>
                    {showPassword ? <VisibilityOff /> : <Visibility />}
                  </IconButton>
                </InputAdornment>
              ),
            }}
          />
        </Grid>
      </Grid>
    </form>
  )
}
